import { render, staticRenderFns } from "./growthDataHisCrop.vue?vue&type=template&id=1744813b&scoped=true"
import script from "./growthDataHisCrop.vue?vue&type=script&lang=js"
export * from "./growthDataHisCrop.vue?vue&type=script&lang=js"
import style0 from "./growthDataHisCrop.vue?vue&type=style&index=0&id=1744813b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744813b",
  null
  
)

export default component.exports